import useDoubtConfig from './useDoubtConfig';
import useDoubtDetails from './useDoubtDetails';
import useFeedBackChoices from './useFeedBackChoices';
import useSubjectAndLanguages from './useSubjectAndLanguages';
import useDoubtDetailsWithoutAuth from './useDoubtDetailsWithoutAuth';

const useFullCustomDoubtsInfo = (goalUID, doubtUID, fallbackData) => {
  const { key: doubtDetailsSWRKey, mutate: revalidateDoubtDetails } =
    useDoubtDetails(goalUID, doubtUID, {
      fallbackData: fallbackData.doubtDetailsData
    });

  const { key: doubtDetailsWithoutAuthSWRKey } = useDoubtDetailsWithoutAuth(
    goalUID,
    doubtUID,
    {
      fallbackData: fallbackData.doubtDetailsWithoutAuthData
    }
  );

  const {
    key: subjectAndLanguagesSWRKey,
    mutate: revalidateSubjectAndLanguage
  } = useSubjectAndLanguages(goalUID, {
    fallbackData: fallbackData.doubtSubjectLanguagesData
  });

  const { key: doubtConfigSWRKey, mutate: revalidateDoubtConfig } =
    useDoubtConfig(goalUID, {
      fallbackData: fallbackData.doubtConfigData
    });

  const { key: feedBackChoicesSWRKey, mutate: revalidateFeedBackChoices } =
    useFeedBackChoices(goalUID, {
      fallbackData: fallbackData.feedBackChoices
    });

  return {
    keys: {
      doubtDetailsSWRKey,
      subjectAndLanguagesSWRKey,
      doubtConfigSWRKey,
      feedBackChoicesSWRKey,
      doubtDetailsWithoutAuthSWRKey
    },
    revalidateSubjectAndLanguage,
    revalidateDoubtConfig,
    revalidateDoubtDetails,
    revalidateFeedBackChoices
  };
};

export default useFullCustomDoubtsInfo;
